let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ayCPI")).then(() => parcelRequire('5a4B6'));